"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4115],{

/***/ 84115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TagsGridComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/components/tag/tag-component.scss.js

var StyledTagComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e23ex4a0"
})("font-size:1.069rem;padding:8px 16px;");

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/components/tag/default-props.js

/* harmony default export */ var default_props = ({
    text: "Tag",
    color: Object.keys(segments_service/* themes */.np)[0]
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/components/tag/tag-component.js









var TagComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TagComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TagComponent);
    function TagComponent() {
        (0,_class_call_check/* default */.Z)(this, TagComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TagComponent, [
        {
            key: "getTagStyle",
            value: function getTagStyle() {
                var color = this.props.color;
                return segments_service/* themes */.np[color];
            }
        },
        {
            key: "render",
            value: function render() {
                var text = this.props.text;
                var tagStyle = this.getTagStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagComponent, {
                    className: "tag-component",
                    style: tagStyle,
                    children: text
                });
            }
        }
    ]);
    return TagComponent;
}(react.PureComponent);

TagComponent.defaultProps = default_props;

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/grid-tag.scss.js

var StyledGridTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1wrfpfv0"
})("display:flex;flex-direction:column;.tag-component-wrapper{display:flex;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var full_paragraph_default_props = __webpack_require__(7484);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var grid_tag_default_props = ({
    tag: default_props,
    fullParagraph: _object_spread_props(_object_spread({}, full_paragraph_default_props/* default */.Z), {
        topic: ""
    })
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/grid-tag.js




function grid_tag_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function grid_tag_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            grid_tag_define_property(target, key, source[key]);
        });
    }
    return target;
}
function grid_tag_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function grid_tag_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        grid_tag_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var GridTag = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GridTag, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GridTag);
    function GridTag() {
        (0,_class_call_check/* default */.Z)(this, GridTag);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(GridTag, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, tag = _props.tag, fullParagraph = _props.fullParagraph, titleSize = _props.titleSize, textSize = _props.textSize;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGridTag, {
                    className: "grid-tag",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tag-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent, grid_tag_object_spread({}, tag))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "full-paragraph-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, grid_tag_object_spread_props(grid_tag_object_spread({}, fullParagraph), {
                                titleSize: titleSize,
                                textSize: textSize
                            }))
                        })
                    ]
                });
            }
        }
    ]);
    return GridTag;
}(react.PureComponent);

GridTag.defaultProps = grid_tag_default_props;

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tags-grid/tags-grid-component.scss.js


var StyledTagsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejrckay0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-wrap:wrap;justify-content:center;padding:0px 56px;.grid-tag-component-wrapper{width:300px;margin:24px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){padding:0px 16px !important;}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tags-grid/tags-grid-component.js




function tags_grid_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_grid_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_grid_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function tags_grid_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function tags_grid_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        tags_grid_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var TagsGridComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TagsGridComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TagsGridComponent);
    function TagsGridComponent() {
        (0,_class_call_check/* default */.Z)(this, TagsGridComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TagsGridComponent, [
        {
            key: "renderGridItems",
            value: function renderGridItems() {
                var _props = this.props, gridItems = _props.gridItems, titleSize = _props.titleSize, textSize = _props.textSize;
                return gridItems.map(function(gridItem, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid-tag-component-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridTag, tags_grid_component_object_spread_props(tags_grid_component_object_spread({}, gridItem), {
                            titleSize: titleSize,
                            textSize: textSize
                        }))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagsGridComponent, {
                    className: "tags-grid-component",
                    children: this.renderGridItems()
                });
            }
        }
    ]);
    return TagsGridComponent;
}(react.PureComponent);

var getGridTagProps = function(tagText, tagColor, fullParagraphTitle, fullParagraphBody) {
    var tag = tags_grid_component_object_spread_props(tags_grid_component_object_spread({}, GridTag.defaultProps.tag), {
        text: tagText,
        color: tagColor
    });
    var fullParagraph = tags_grid_component_object_spread_props(tags_grid_component_object_spread({}, GridTag.defaultProps.fullParagraph), {
        title: fullParagraphTitle,
        body: fullParagraphBody
    });
    return tags_grid_component_object_spread_props(tags_grid_component_object_spread({}, GridTag.defaultProps), {
        tag: tag,
        fullParagraph: fullParagraph
    });
};
TagsGridComponent.defaultProps = {
    gridItems: [
        getGridTagProps("Views", "pink", "Gain valuable insights", "Look at your data differently with multiple View options from Calendar to Map."),
        getGridTagProps("Automations", "green", "Turn on your autopilot", "Automate repetitive tasks and have more time for the work that motivates you."),
        getGridTagProps("Dashboards", "purple", "See the bigger picture", "Get a high-level overview at a glance and make smarter decisions, faster.")
    ],
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.MD,
    textSize: sizes.MD
};


/***/ })

}]);